import React, { useState } from 'react';
import { gtmEventHandler } from '@common/utils/gtm';
import { Tappable } from '@common/ui/general';
import { useMediaQuery } from '@common/hooks';

import BreadcrumbContainer from '@alumni_v2/ui/BreadcrumbContainer';
import ReviewFiltersRevamp from '@alumni_v2/ui/ReviewFiltersRevamp';
import PlacementBanner
  from '@alumni_v2/ui/PlacementBannerV2/PlacementBanner';

import RatingIcon from '@alumni_v2/images/svg/rating.svg';

import styles from './AlumniWrapperV2.module.scss';

const AlumniWrapperV2 = ({ children }) => {
  const { mobile } = useMediaQuery();
  const [showReadMore, setShowReadMore] = useState(true);
  return (
    <>
      {mobile && <PlacementBanner />}
      <div className={styles.container}>
        <div className={styles.outerWrapper}>
          <div className={styles.headerContainer}>
            <div className={styles.reviewHeading}>
              <BreadcrumbContainer />
              <div className={styles.reviewRating}>
                <h1 className={styles.headingText}>Scaler Reviews</h1>
                <div className={styles.ratingContainer}>
                  <div className={styles.rating}>
                    <img src={RatingIcon} alt="rating-icon" />
                    <div className={styles.ratingText}>4.7</div>
                  </div>
                  { !mobile && (
                    <div className={styles.ratingCount}>
                      (4,292 learners)
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.desc}>
              {mobile ? (
                <>
                  {showReadMore ? (
                    `At Scaler, learners transform their careers,
                    mastering c...`
                  ) : (
                    <>
                      At Scaler, learners transform their careers, mastering
                      coding and securing dream jobs. Discover genuine insights
                      through honest reviews and testimonials.
                    </>
                  )}
                  <Tappable
                    className={styles.readMore}
                    onClick={() => {
                      setShowReadMore(!showReadMore);
                      gtmEventHandler(
                        'cta',
                        showReadMore ? 'readmore' : 'read less',
                        'click',
                        'alumni_directory',
                        {
                          click_type: showReadMore ? 'readmore' : 'read less',
                          click_section: 'review_header',
                        },
                      );
                    }}
                  >
                    {!showReadMore ? 'Read Less' : 'Read More'}
                  </Tappable>
                </>
              ) : (
                `At Scaler, learners transform their careers, mastering
                coding and securing dream jobs. Discover genuine insights
                through honest reviews and testimonials.`
              )}
            </div>
          </div>
          <div>
            <ReviewFiltersRevamp />
          </div>
        </div>
        <div className={styles.mainContainer}>
          <div className={styles.rightContainer}>
            <div className={styles.reviewsContainer}>{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AlumniWrapperV2;
